import { autoinject } from 'aurelia-framework';
import { Location } from "../../models/location";
import * as State from "../../store/state";
import IState = State.IState;
import { Subscription } from "rxjs";
import { Store } from 'aurelia-store';
import { applicationLogger } from "../../logging/logger";
import { MdTabs } from "aurelia-materialize-bridge";

@autoinject
export class NotificationRecipientsTableau {
	locations: Array<Location>;
	selectedLocation: Location;
	isActive: boolean = false;
	tabs: MdTabs;

	protected applicationState: IState;
	protected subscription: Subscription;
	protected store: Store<IState>;

	constructor(store: Store<IState>) {
		this.store = store;
	}

	unbind() {
		this.subscription.unsubscribe();
	}

	bind(bindingContext: any, overrideContext: any) {
		this.locations = bindingContext.applicationState.locationState.selectedLocations;
		this.subscription = this.store.state.subscribe((state) => {
			this.applicationState = state;
			this.locations = this.applicationState.locationState.selectedLocations;
			this.selectedLocation = this.getCurrentLocation();
		});
	}

	attached() {
		// wait 100 ms to allow the MdTabs attached method to fire and thus create an instance of the underlying tab control
		// otherwise the call to tabs.select will fail.
		setTimeout(() => {
			if (this.selectedLocation) {
				if (this.locations && this.locations.length > 0 &&
					this.selectedLocation &&
					this.selectedLocation.id !== this.locations[0].id) {
					this.tabs.select(this.selectedLocation.id);
				}
			}
		}, 100);
	}

	getCurrentLocation(): Location {
		const currentLocationId = localStorage.getItem("current-location");
		if (!currentLocationId) {
			return this.locations[0];
		}

		const currentLocations = this.locations.filter(l => l.id === currentLocationId);
		return currentLocations[0];
	}

	async onTabSelected($event) {
		const locationId = $event.detail.substring(1);
		localStorage.setItem("current-location", locationId);
	}
}